export type ForecastArrayProduct = {
  key: string;
  label: string;
};

export const forecastArrayProductOptions: ForecastArrayProduct[] = [
  {
    key: "Gas (Mcf)",
    label: "Gas (Mcf)"
  },
  {
    key: "Oil (bbl)",
    label: "Oil (bbl)"
  },
  {
    key: "Condensate (bbl)",
    label: "Condensate (bbl)"
  },
  {
    key: "Water (bbl)",
    label: "Water (bbl)"
  }
];
